/**
 * Hindi Translations (हिन्दी)
 */

import type { Translations } from '../types';

export const hi: Translations = {
  language: 'hi',
  languageName: 'हिन्दी',

  common: {
    demo: 'डेमो',
    privacy: 'गोपनीयता',
    terms: 'शर्तें',
  },

  privacy: {
    title: 'गोपनीयता नीति',
    whatWeStore: 'हम क्या संग्रहीत करते हैं',
    whatWeStoreDesc:
      'हम आयु अनुमान के लिए अस्थायी रूप से चेहरे की ज्यामिति संसाधित करते हैं। सत्यापन पूरा होने के बाद कोई छवि या बायोमेट्रिक टेम्पलेट संग्रहीत नहीं किया जाता।',
    whatWeDont: 'हम क्या संग्रहीत नहीं करते',
    whatWeDontDesc:
      'हम फ़ोटो, वीडियो या बायोमेट्रिक पहचानकर्ता संग्रहीत नहीं करते। आपका चेहरा डेटा ब्राउज़र में संसाधित होता है और तुरंत हटा दिया जाता है।',
    whyWeUseIt: 'हम इसका उपयोग क्यों करते हैं',
    whyWeUseItDesc:
      'आयु अनुमान वेबसाइटों को व्यक्तिगत दस्तावेज़ों की आवश्यकता के बिना आयु प्रतिबंध नियमों का पालन करने में मदद करता है।',
    readFull: 'हमारी पूरी',
    privacyPolicyLink: 'गोपनीयता नीति',
  },

  theme: {
    system: 'सिस्टम',
    light: 'लाइट',
    dark: 'डार्क',
  },

  face: {
    noFace: 'कोई चेहरा नहीं मिला',
    tooFar: 'चेहरा बहुत दूर है',
    tooClose: 'चेहरा बहुत पास है',
    offCenter: 'चेहरा केंद्र में नहीं है',
    poorLighting: 'रोशनी कम है',
    good: 'विश्लेषण हो रहा है, रुकें...',
    holdStill: 'विश्लेषण हो रहा है, रुकें...',
    holdStillCountdown: 'स्थिर रहें... {count}',
    processing: 'प्रोसेसिंग...',
    looking: 'कोई चेहरा नहीं मिला',
    centerFace: 'चेहरा केंद्र में नहीं है',
    moveCloser: 'चेहरा बहुत दूर है',
    moveBack: 'चेहरा बहुत पास है',
    keepInPosition: 'स्थिति बनाए रखें',
    perfect: 'बिल्कुल सही',
    centerInFrame: 'चेहरे को फ्रेम में रखें',
    outsideOval: 'चेहरा अंडाकार के बाहर है',
  },

  liveness: {
    blink: {
      title: 'पलकें झपकाएं',
      hint: 'धीरे से एक बार पलकें झपकाएं',
    },
    smile: {
      title: 'मुस्कुराएं',
      hint: 'स्वाभाविक मुस्कान दिखाएं',
    },
    lookLeft: {
      title: 'बाईं ओर देखें',
      hint: 'धीरे से अपना सिर बाईं ओर घुमाएं',
    },
    lookRight: {
      title: 'दाईं ओर देखें',
      hint: 'धीरे से अपना सिर दाईं ओर घुमाएं',
    },
    openMouth: {
      title: 'मुंह खोलें',
      hint: 'अपना मुंह चौड़ा खोलें',
    },
    lookUp: {
      title: 'ऊपर देखें',
      hint: 'अपना सिर ऊपर उठाएं',
    },
    lookDown: {
      title: 'नीचे देखें',
      hint: 'अपना सिर नीचे झुकाएं',
    },
    raiseBrows: {
      title: 'भौहें उठाएं',
      hint: 'अपनी भौहें ऊपर उठाएं',
    },
    improveLighting: {
      title: 'रोशनी सुधारें',
      hint: 'जारी रखने के लिए अधिक रोशनी वाली जगह पर जाएं',
    },
  },

  document: {
    selectType: 'अपने दस्तावेज़ का प्रकार चुनें',
    captureFront: 'दस्तावेज़ का अगला भाग कैप्चर करें',
    captureBack: 'दस्तावेज़ का पिछला भाग कैप्चर करें',
    processing: 'आपका दस्तावेज़ प्रोसेस हो रहा है...',
    tips: {
      goodLighting: 'अच्छी रोशनी सुनिश्चित करें',
      flatSurface: 'दस्तावेज़ को समतल सतह पर रखें',
      allCorners: 'सुनिश्चित करें कि सभी कोने दिखाई दे रहे हैं',
      noGlare: 'चमक और छाया से बचें',
    },
    types: {
      passport: 'पासपोर्ट',
      idCard: 'पहचान पत्र',
      driversLicense: 'ड्राइविंग लाइसेंस',
    },
  },

  ui: {
    continue: 'जारी रखें',
    next: 'आगे',
    retry: 'पुनः प्रयास करें',
    startOver: 'फिर से शुरू करें',
    cancel: 'रद्द करें',
    success: 'आयु जांच पास',
    failure: 'आयु जांच विफल',
    loading: 'लोड हो रहा है...',
    error: 'एक त्रुटि हुई',
    permissionRequired: 'अनुमति आवश्यक',
    cameraPermission: 'कैमरा एक्सेस आवश्यक है',
    goBack: 'वापस जाएं',
    switchCamera: 'कैमरा बदलें',
    completeVerification: 'पूर्ण करें',
    continueToId: 'ID जांच जारी रखें',
  },

  errors: {
    cameraNotFound: 'इस डिवाइस पर कोई कैमरा नहीं मिला',
    cameraPermissionDenied: 'कैमरा की अनुमति अस्वीकार कर दी गई',
    cameraInUse: 'कैमरा किसी अन्य एप्लिकेशन द्वारा उपयोग में है',
    cameraNotSupported: 'कैमरा आवश्यक सेटिंग्स का समर्थन नहीं करता',
    cameraSecurityError: 'कैमरा के लिए HTTPS कनेक्शन आवश्यक है',
    networkError: 'नेटवर्क त्रुटि। कृपया अपना कनेक्शन जांचें।',
    timeout: 'अनुरोध समय समाप्त। कृपया पुनः प्रयास करें।',
    invalidApiKey: 'अमान्य API कुंजी',
    sessionExpired: 'सत्र समाप्त। कृपया फिर से शुरू करें।',
    verificationFailed: 'जांच विफल। कृपया पुनः प्रयास करें।',
    unknownError: 'एक अप्रत्याशित त्रुटि हुई',
    cameraAccessDeniedDetailed: 'कृपया जारी रखने के लिए कैमरा एक्सेस दें।',
    cameraNotFoundDetailed: 'कोई कैमरा नहीं मिला। कृपया कैमरा कनेक्ट करें और पुनः प्रयास करें।',
    cameraInUseDetailed:
      'कैमरा किसी अन्य एप्लिकेशन द्वारा उपयोग में है। कृपया उसे बंद करें और पुनः प्रयास करें।',
    cameraOverconstrained:
      'कैमरा अनुरोधित रिज़ॉल्यूशन का समर्थन नहीं करता। डिफ़ॉल्ट सेटिंग्स से प्रयास किया जा रहा है...',
    networkTimeout: 'अनुरोध में बहुत समय लगा। कृपया अपना कनेक्शन जांचें और पुनः प्रयास करें।',
    networkOffline: 'आप ऑफ़लाइन प्रतीत होते हैं। कृपया अपना इंटरनेट कनेक्शन जांचें।',
    apiGenericError: 'कुछ गलत हो गया। कृपया पुनः प्रयास करें।',
    faceNotDetected: 'कृपया अपना चेहरा फ्रेम में रखें।',
    livenessFailed: 'जीवितता जांच विफल। कृपया पुनः प्रयास करें।',
    documentCaptureFailed:
      'दस्तावेज़ कैप्चर नहीं हो सका। कृपया अच्छी रोशनी सुनिश्चित करें और पुनः प्रयास करें।',
    initializationFailed: 'लोड करने में विफल। कृपया रीफ्रेश करें और पुनः प्रयास करें।',
    modelLoadFailed: 'आवश्यक घटक लोड करने में विफल। कृपया पेज रिफ्रेश करें और पुनः प्रयास करें।',
    unexpectedError: 'एक अप्रत्याशित त्रुटि हुई। कृपया पुनः प्रयास करें।',
    configError: 'कॉन्फ़िगरेशन त्रुटि। कृपया सहायता से संपर्क करें।',
  },

  screens: {
    welcome: {
      title: '18+ आयु जाँच',
      subtitle: 'गुमनाम आयु जाँच',
      startButton: 'शुरू करें',
      secureNote: 'सुरक्षित और एन्क्रिप्टेड',
      ageTechBy: 'आयु तकनीक AppBouncer द्वारा',
      waitingCamera: 'कैमरा एक्सेस की प्रतीक्षा',
      allowCamera: 'कैमरा एक्सेस की अनुमति दें',
      noBiometric: 'कोई बायोमेट्रिक डेटा संग्रहीत नहीं',
      loading: 'लोड हो रहा है...',
      loadingRequirements: 'आवश्यकताएँ लोड हो रही हैं...',
    },
    permissions: {
      title: 'लोड हो रहा है ...',
      description: 'कृपया पूछने पर कैमरा एक्सेस की अनुमति दें',
      allowButton: 'कैमरा एक्सेस की अनुमति दें',
      privacyNote: 'आपका डेटा एन्क्रिप्टेड और सुरक्षित है',
      goodLighting: 'अच्छी रोशनी!',
      goodLightingHint: 'सुनिश्चित करें कि आपका चेहरा अच्छी तरह से रोशन है',
      getReady: 'तैयार हो जाइए',
      removeCoverings: 'फेस कवरिंग हटाएँ',
      removeGlasses: 'चश्मा हटाएँ',
    },
    facePosition: {
      title: 'अपना चेहरा स्थित करें',
      hint: 'चेहरा केंद्र में रखें',
      step: 'चरण',
      stepOf: 'चरण {current} में से {total}',
      lookingForFace: 'चेहरा खोज रहे हैं...',
    },
    livenessCheck: {
      title: 'जीवितता जांच',
      followInstructions: 'निर्देशों का पालन करें',
      preparing: 'तैयारी हो रही है...',
      complete: 'जीवंतता सत्यापित!',
      actionAutoDetected: 'क्रिया स्वचालित रूप से पहचानी जाएगी',
      failed: 'जीवितता जांच विफल',
      failedDescription:
        'हम आपकी जीवितता सत्यापित नहीं कर सके। कृपया अच्छी रोशनी सुनिश्चित करें, सीधे कैमरे की ओर देखें, और स्क्रीन पर दिए निर्देशों का पालन करें।',
      retryButton: 'जीवंतता जांच पुनः करें',
      restartButton: 'फिर से शुरू करें',
    },
    ageEstimation: {
      title: 'स्थिर रहें',
      analyzing: 'विश्लेषण हो रहा है...',
      analyzingProgress: 'चेहरा {current} में से {total} का विश्लेषण हो रहा है...',
      estimatedAge: 'अनुमानित आयु',
      holdStill: 'स्थिर रहें',
      verified: 'आयु सत्यापित',
      verificationUncertain: 'आयु अनिश्चित',
      estimationComplete: 'आयु जांच पूर्ण',
      confirmedAge: '{minAge}+ वर्ष की पुष्टि',
      couldNotConfirm: '{minAge}+ आयु की पुष्टि नहीं हो सकी',
      ageConfirmed: 'आयु पुष्ट',
      aboveMinimumAge: 'आप न्यूनतम आयु आवश्यकता पूरी करते हैं',
      belowMinimumAge: 'न्यूनतम आयु से कम',
      documentRequired: 'दस्तावेज़ आवश्यक',
      uploadDocumentMessage: 'कृपया अपनी आयु सत्यापित करने के लिए एक वैध पहचान पत्र अपलोड करें',
      idHint: 'आईडी कार्ड, पासपोर्ट, या ड्राइविंग लाइसेंस',
      confidenceLevels: 'आयु सीमा के अनुसार विश्वास',
      confidence: 'विश्वास',
      years: 'वर्ष',
      continueToId: 'ID जांच जारी रखें',
      demoComplete: 'डेमो मोड पूर्ण। प्रोडक्शन में, आपको रीडायरेक्ट किया जाएगा।',
      improveLighting: 'रोशनी सुधारें',
      improveLightingHint: 'सटीक परिणामों के लिए अधिक रोशनी वाली जगह पर जाएं',
    },
    documentSelect: {
      title: 'दस्तावेज़ प्रकार चुनें',
      description: 'उस पहचान दस्तावेज़ का प्रकार चुनें जिसे आप स्कैन करेंगे',
      idCard: 'राष्ट्रीय पहचान पत्र',
      idCardHint: 'सरकार द्वारा जारी आईडी',
      passport: 'पासपोर्ट',
      passportHint: 'केवल फोटो पेज',
      driversLicense: 'ड्राइविंग लाइसेंस',
      driversLicenseHint: 'वैध ड्राइविंग लाइसेंस',
    },
    captureMode: {
      captureFrontSide: 'सामने का भाग कैप्चर करें',
      captureBackSide: 'पीछे का भाग कैप्चर करें',
      chooseMethod: 'अपना दस्तावेज़ कैप्चर करने का तरीका चुनें',
      useCamera: 'कैमरा उपयोग करें',
      useCameraHint: 'अपने दस्तावेज़ की फोटो लें',
      uploadFile: 'फ़ाइल अपलोड करें',
      uploadFileHint: 'अपने डिवाइस से चुनें',
    },
    documentCamera: {
      frontSide: 'सामने का भाग',
      backSide: 'पीछे का भाग',
      positionInFrame: 'दस्तावेज़ को फ्रेम में रखें',
      scanFront: 'दस्तावेज़ का सामने का भाग स्कैन करें',
      scanBack: 'दस्तावेज़ का पीछे का भाग स्कैन करें',
      keepFlat: 'दस्तावेज़ को समतल और अच्छी रोशनी में रखें',
      capturePhoto: 'फोटो कैप्चर करें',
    },
    documentPreview: {
      frontPreview: 'सामने का प्रीव्यू',
      backPreview: 'पीछे का प्रीव्यू',
      lookingGood: 'अच्छा दिख रहा है!',
      checkDetails: 'सुनिश्चित करें कि सभी विवरण स्पष्ट दिखाई दे रहे हैं',
      imageQuality: 'छवि गुणवत्ता',
      qualityGood: 'अच्छी',
      usePhoto: 'यह फोटो उपयोग करें',
      retakePhoto: 'फोटो फिर से लें',
    },
    documentCapture: {
      captureFront: 'सामने का भाग कैप्चर करें',
      captureBack: 'पीछे का भाग कैप्चर करें',
      alignDocument: 'दस्तावेज़ को फ्रेम के भीतर संरेखित करें',
      captureButton: 'कैप्चर करें',
      retakeButton: 'फिर से लें',
      confirmButton: 'पुष्टि करें',
      frontSide: 'सामने का भाग',
      backSide: 'पीछे का भाग',
      positionDocument: 'अपना दस्तावेज़ फ्रेम में रखें',
      alignWithFrame: 'दस्तावेज़ को फ्रेम के साथ संरेखित करें',
      positionFrontId: 'आईडी का सामने का भाग रखें',
      positionBackId: 'आईडी का पीछे का भाग रखें',
      scanFrontId: 'आईडी का सामने का भाग स्कैन करें',
      scanBackId: 'आईडी का पीछे का भाग स्कैन करें',
      positionWithinFrame: 'सामने का भाग फ्रेम में रखें',
      flipAndScan: 'अपनी आईडी पलटें और पीछे का भाग स्कैन करें',
      goodLight: 'अच्छी रोशनी',
      flatSurface: 'समतल सतह',
      frontCaptured: 'सामने का भाग कैप्चर हुआ',
      captureIdCard: 'पहचान पत्र कैप्चर करें',
      capturePassport: 'पासपोर्ट कैप्चर करें',
      captureDriversLicense: 'ड्राइविंग लाइसेंस कैप्चर करें',
    },
    processing: {
      title: 'प्रोसेसिंग',
      description: 'कृपया प्रोसेस होने तक प्रतीक्षा करें',
      analyzingDocument: 'दस्तावेज़ का विश्लेषण हो रहा है...',
      almostDone: 'लगभग पूर्ण...',
      faceVerified: 'चेहरा सत्यापित',
      livenessConfirmed: 'जीवितता पुष्ट',
      processingDocuments: 'दस्तावेज़ प्रोसेस हो रहे हैं...',
    },
    success: {
      title: 'आयु जाँच उत्तीर्ण',
      description: 'आयु और जीवंतता जाँच पूर्ण',
      redirecting: 'रीडायरेक्ट हो रहा है...',
      summary: 'सारांश',
      faceMatch: 'चेहरा मिलान',
      liveness: 'जीवितता',
      age: 'आयु',
      idDocument: 'आईडी दस्तावेज़',
      pass: 'पास',
      fail: 'फेल',
      valid: 'वैध',
      notApplicable: 'लागू नहीं',
      done: 'पूर्ण',
      feedbackTitle: 'कृपया अपने अनुभव को रेट करें',
      feedbackPlaceholder: 'हमें बताएं कि हम कैसे सुधार कर सकते हैं...',
      skip: 'छोड़ें',
      submit: 'जमा करें',
    },
    failure: {
      title: 'आयु जांच विफल',
      description: 'जांच पूरी नहीं हो सकी। कृपया पुनः प्रयास करें।',
      tryAgainButton: 'पुनः प्रयास करें',
      leaveButton: 'छोड़ें',
      attemptsLeft: '{{count}} प्रयास शेष',
      noAttemptsLeft: 'कोई और प्रयास उपलब्ध नहीं',
    },
    error: {
      title: 'कॉन्फ़िगरेशन आवश्यक',
      description: 'URL में कुछ आवश्यक पैरामीटर गायब हैं। कृपया वेबसाइट व्यवस्थापक से संपर्क करें।',
      missingParams: 'गायब पैरामीटर',
      requiredParams: 'आवश्यक पैरामीटर',
      technicalDetails: 'तकनीकी विवरण',
      urlMustInclude: 'URL में ये क्वेरी पैरामीटर शामिल होने चाहिए:',
    },
    underage: {
      title: 'आयु आवश्यकता पूरी नहीं हुई',
      description: 'इस सेवा तक पहुंचने के लिए आपकी आयु कम से कम {{minAge}} वर्ष होनी चाहिए।',
    },
    consent: {
      title: 'आयु जांच सुधारने में मदद करें',
      description:
        'AppBouncer को आयु सत्यापन और फ़ॉलबैक जांच में सुधार के लिए थोड़ी मात्रा में अनाम उपयोग डेटा (जैसे फीड कैप्चर) एकत्र करने की अनुमति दें। आपका डेटा कभी बेचा या तीसरे पक्ष को नहीं दिया जाता।',
      allowButton: 'अनुमति दें',
    },
    documentConsent: {
      title: 'दस्तावेज़ आवश्यक',
      description:
        'जांच पूरी करने के लिए, हमें एक आधिकारिक दस्तावेज़ से आपकी आयु सत्यापित करनी होगी। क्या आप अपना पहचान पत्र अपलोड करने की सहमति देते हैं?',
      allowButton: 'दस्तावेज़ के साथ जारी रखें',
      declineButton: 'अस्वीकार करें',
      privacyNote:
        'आपका दस्तावेज़ सुरक्षित रूप से संसाधित किया जाएगा और जांच के बाद हटा दिया जाएगा।',
    },
    selfDeclaration: {
      title: 'आपकी जन्म तिथि',
      description: 'कृपया जारी रखने के लिए अपनी जन्म तिथि दर्ज करें',
      day: 'दिन',
      month: 'महीना',
      year: 'वर्ष',
      yourAge: 'आपकी आयु:',
      years: 'वर्ष',
      confirmButton: 'जारी रखें',
      months: {
        january: 'जनवरी',
        february: 'फरवरी',
        march: 'मार्च',
        april: 'अप्रैल',
        may: 'मई',
        june: 'जून',
        july: 'जुलाई',
        august: 'अगस्त',
        september: 'सितंबर',
        october: 'अक्टूबर',
        november: 'नवंबर',
        december: 'दिसंबर',
      },
    },
  },

  lighting: {
    warning: 'रोशनी की समस्या',
    adjust: 'रोशनी समायोजित करें',
    lowLight: 'कम रोशनी का पता चला',
    tooBright: 'बहुत तेज़ रोशनी',
    poorContrast: 'कम कंट्रास्ट',
    improveLighting: 'बेहतर रोशनी खोजें',
    moveToLighter: 'अधिक रोशनी वाली जगह पर जाएं',
    videoNotReady: 'वीडियो तैयार नहीं है',
  },

  steps: {
    faceDetection: 'चेहरा पहचान',
    liveness: 'जीवंतता जाँच',
    age: 'आयु जांच',
    documentScan: 'दस्तावेज़ स्कैन',
    selfDeclaration: 'स्व-घोषणा',
  },

  status: {
    cameraStarted: 'कैमरा शुरू हुआ',
    cameraReady: 'कैमरा तैयार',
    cameraAccessDenied: 'कैमरा एक्सेस अस्वीकार',
    cameraError: 'कैमरा त्रुटि',
    cameraNotAvailable: 'कैमरा उपलब्ध नहीं',
    noFaceDetected: 'कोई चेहरा नहीं मिला',
    livenessVerified: 'जीवितता सत्यापित',
    livenessCheckFailed: 'जीवितता जांच विफल',
    verifyingAge: 'आयु सत्यापित हो रही है...',
    processingDocument: 'दस्तावेज़ प्रोसेस हो रहा है...',
    documentProcessed: 'दस्तावेज़ सफलतापूर्वक प्रोसेस हुआ',
    verificationCancelled: 'जांच रद्द',
    improveLightingForAge: 'सटीक परिणामों के लिए रोशनी सुधारें',
    getReady: 'तैयार हो जाइए',
    preparingLiveness: 'जीवितता जांच तैयार हो रही है...',
    uploadingSelfie: 'सेल्फ़ी छवियां अपलोड हो रही हैं...',
    preparingUpload: 'अपलोड तैयार हो रहा है...',
    uploadingFront: 'सामने का दस्तावेज़ अपलोड हो रहा है...',
    uploadingBack: 'पीछे का दस्तावेज़ अपलोड हो रहा है...',
    processingDocuments: 'दस्तावेज़ प्रोसेस हो रहे हैं...',
    documentSubmissionFailed: 'दस्तावेज़ जमा करना विफल। कृपया पुनः प्रयास करें।',
    selectJpegOrPng: 'कृपया JPEG या PNG छवि चुनें',
    fileTooLarge: 'फ़ाइल बहुत बड़ी है। अधिकतम 5MB अनुमत।',
    errorReadingFile: 'फ़ाइल पढ़ने में त्रुटि',
    frontDocumentRequired: 'सामने के दस्तावेज़ की छवि आवश्यक',
    verificationFailedClose: 'जांच विफल। आपको वापस रीडायरेक्ट किया जाएगा।',
    verificationCompleteClose: 'जांच पूर्ण! आपको वापस रीडायरेक्ट किया जाएगा।',
    analyzingFace: 'चेहरे का विश्लेषण हो रहा है...',
  },
};
